import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, withCtx as _withCtx, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withKeys as _withKeys, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = {
  key: 0,
  class: "play-video-button"
}
const _hoisted_4 = {
  key: 0,
  ref: "blurCanvas",
  width: "32",
  height: "32",
  class: "preview preview-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "name-container"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconPlayCircleOutline = _resolveComponent("IconPlayCircleOutline")
  const _component_NcProgressBar = _resolveComponent("NcProgressBar")
  const _component_NcLoadingIcon = _resolveComponent("NcLoadingIcon")
  const _component_TransitionWrapper = _resolveComponent("TransitionWrapper")
  const _component_IconClose = _resolveComponent("IconClose")
  const _component_NcButton = _resolveComponent("NcButton")

  return (_openBlock(), _createBlock(_resolveDynamicComponent($options.filePreviewElement), _mergeProps({
    tabindex: $options.wrapperTabIndex,
    class: ["file-preview", {
			'file-preview--viewer-available': $options.isViewerAvailable,
			'file-preview--upload-editor': $props.isUploadEditor,
			'file-preview--shared-items-grid': $props.isSharedItems && !$props.rowLayout,
			'file-preview--row-layout': $props.rowLayout,
		}]
  }, $options.filePreviewBinding, {
    onClick: _withModifiers($options.handleClick, ["exact"]),
    onKeydown: _withKeys($options.handleClick, ["enter"])
  }), {
    default: _withCtx(() => [
      _createElementVNode("span", {
        title: $props.file.name,
        class: _normalizeClass(["image-container", { playable: $options.isPlayable }]),
        style: _normalizeStyle($options.imageContainerStyle)
      }, [
        _createElementVNode("img", {
          class: _normalizeClass(["file-preview__image", $options.previewImageClass]),
          alt: $props.file.name,
          src: $data.failed ? $options.defaultIconUrl : $options.previewUrl,
          onLoad: _cache[0] || (_cache[0] = (...args) => ($options.onLoad && $options.onLoad(...args))),
          onError: _cache[1] || (_cache[1] = (...args) => ($options.onError && $options.onError(...args)))
        }, null, 42, _hoisted_2),
        (!$data.isLoading || $options.fallbackLocalUrl)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              ($options.isPlayable && !$props.smallPreview)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createVNode(_component_IconPlayCircleOutline, {
                      size: 48,
                      "fill-color": "#ffffff"
                    })
                  ]))
                : _createCommentVNode("", true),
              ($options.showUploadProgress)
                ? (_openBlock(), _createBlock(_component_NcProgressBar, {
                    key: 1,
                    class: "file-preview__progress",
                    type: "circular",
                    value: $options.uploadProgress
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ], 64))
          : ($data.isLoading)
            ? (_openBlock(), _createBlock(_component_TransitionWrapper, {
                key: 1,
                name: "fade"
              }, {
                default: _withCtx(() => [
                  ($props.file.blurhash)
                    ? (_openBlock(), _createElementBlock("canvas", _hoisted_4, null, 512))
                    : (_openBlock(), _createBlock(_component_NcLoadingIcon, {
                        key: 1,
                        class: "preview preview-loading"
                      }))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ], 14, _hoisted_1),
      ($props.isUploadEditor)
        ? (_openBlock(), _createBlock(_component_NcButton, {
            key: 0,
            class: "remove-file",
            tabindex: "1",
            variant: "primary",
            "aria-label": $options.removeAriaLabel,
            onClick: _withModifiers($options.handleClick, ["stop","prevent"])
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconClose)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]))
        : _createCommentVNode("", true),
      ($options.shouldShowFileDetail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($options.fileDetail), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["tabindex", "class", "onClick", "onKeydown"]))
}